module.exports = __webpack_public_path__ + "00d02b21465875d2275775f47a50410a.pdf";